import { displayCurrencyWithPrecision } from '@utils/currency';

const AMOUNT_TOKEN = '{{amount}}';

interface ApplyFactorAmountParams {
  amount: number | null;
  copy: string;
  currency: string;
  pricePrecision: number;
}

/**
 * Substitutes a factor's money figure into its `{{amount}}` token, formatted in the event's
 * currency.
 *
 * The model service emits a bare, already-FX-converted number with no symbol or currency code,
 * and the server deliberately leaves the token unfilled rather than guessing one — so the symbol
 * is applied here, through the same formatter the grid cell uses. That keeps one source of truth
 * for how money looks.
 *
 * A factor with no money in its sentence has no token and a null amount, and passes through
 * untouched. If an amount is somehow missing for a sentence that wants one, the token is left
 * visible rather than rendering a bare or invented number.
 */
export const applyFactorAmount = ({
  amount,
  copy,
  currency,
  pricePrecision,
}: ApplyFactorAmountParams): string => {
  if (amount == null || !copy.includes(AMOUNT_TOKEN)) return copy;

  return copy.replaceAll(AMOUNT_TOKEN, displayCurrencyWithPrecision(amount, currency, pricePrecision));
};
